import React, { useState } from 'react';
import './OwnerForm.css';
import { IoChevronBackOutline } from "react-icons/io5";
// ==== تم استبدال استدعاءات Firebase بـ apiClient ====
import apiClient from '../../api/axiosConfig';

function OwnerForm() {
  // استخدام كائن واحد لتخزين بيانات النموذج
  const [formData, setFormData] = useState({
    employer_name: '',
    employer_email: '',
    employer_phone: '',
    title: '',
    description: '',
  });

  // حالات لإدارة حالة الإرسال والـ Popup
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState('success');
  const [popupMessage, setPopupMessage] = useState('');

  // دالة لتحديث حالة النموذج عند تغيير المدخلات
  const handleInputChange = (e) => {
    const { name } = e.target;
    let { value } = e.target;
    if (name === 'employer_phone') {
      const normalizeToAsciiDigits = (s) => s
        .replace(/[\u0660-\u0669]/g, (c) => String(c.charCodeAt(0) - 0x0660))
        .replace(/[\u06F0-\u06F9]/g, (c) => String(c.charCodeAt(0) - 0x06F0));
      value = normalizeToAsciiDigits(value).replace(/\D/g, '');
    }
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  // ==== تم استبدال دالة Firebase بدالة تستدعي Laravel API ====
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // إرسال طلب POST إلى Laravel API
      const response = await apiClient.post('/job-postings', formData);

      if (response.status === 201) {
        setPopupMessage('تم إرسال طلبك بنجاح وسنراجعه قريباً.');
        setPopupType('success');
        // تفريغ النموذج
        setFormData({
          employer_name: '',
          employer_email: '',
          employer_phone: '',
          title: '',
          description: '',
        });
      }
    } catch (error) {
      console.error("Error sending owner form:", error);
      // التعامل مع أخطاء التحقق من الصحة (Validation)
      if (error.response && error.response.status === 422) {
        setPopupMessage('يرجى التأكد من أن كل الحقول مملوءة بشكل صحيح.');
      } else {
        setPopupMessage('حدث خطأ أثناء إرسال الطلب. يرجى المحاولة مرة أخرى.');
      }
      setPopupType('failure');
    } finally {
      setIsSubmitting(false);
      setShowPopup(true);
    }
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
      <div className="container my-5 form-container">
        <form dir="rtl" onSubmit={handleSubmit} method='POST'>
          <div className="form-row row">
            <div className="form-group col-md-6">
              <input type="text" className="form-control" placeholder='الاسم بالكامل'
                     name='employer_name' // مطابقة لأسماء حقول Laravel
                     value={formData.employer_name}
                     onChange={handleInputChange}
                     required
              />
            </div>
            <div className="form-group col-md-6">
              <input type="email" className="form-control" placeholder='البريد الالكترونى'
                     name='employer_email' // مطابقة لأسماء حقول Laravel
                     value={formData.employer_email}
                     onChange={handleInputChange}
                     required
              />
            </div>
          </div>

          <div className="form-row row">
            <div className="form-group col-md-6">
              <input type="tel" className="form-control" placeholder='رقم الهاتف للتواصل' dir='rtl'
                     name='employer_phone' // مطابقة لأسماء حقول Laravel
                     value={formData.employer_phone}
                     onChange={handleInputChange}
                     inputMode="numeric" pattern="^[0-9]{7,15}$" minLength={7} maxLength={15} title="يرجى إدخال رقم هاتف صحيح (أرقام فقط بين 7 و15 خانة)" required
              />
            </div>
            <div className="form-group col-md-6">
              <input type="text" className="form-control" placeholder='المسمى الوظيفى'
                     name='title' // مطابقة لأسماء حقول Laravel
                     value={formData.title}
                     onChange={handleInputChange}
                     required
              />
            </div>
          </div>

          <div className="form-row row">
            <div className="form-group col-md-12">
            <textarea className="form-control" cols={5} rows={10} placeholder='وصف الوظيفة'
                      name='description' // مطابقة لأسماء حقول Laravel
                      value={formData.description}
                      onChange={handleInputChange}
                      required
            />
            </div>
          </div>

          <div className="form-row row">
            <div className="col-md-3 d-flex justify-content-center">
              <button type="submit" className="btn submit-btn" disabled={isSubmitting}>
                {isSubmitting ? 'جاري الإرسال...' : 'ارسل طلبك'}
                <IoChevronBackOutline />
              </button>
            </div>
          </div>
        </form>

        {showPopup && (
            <div className="popup" onClick={handleClosePopup}>
              <div
                  className={`popup-content ${popupType === 'success' ? 'popup-success' : 'popup-failure'}`}
                  onClick={(e) => e.stopPropagation()}
              >
                <span className="close" onClick={handleClosePopup}>&times;</span>
                <p>{popupMessage}</p>
              </div>
            </div>
        )}
      </div>
  );
};

export default OwnerForm;